import { ICopyColetaPrecoFornecedorUseCase } from "../../../presentation/useCases/create/copy_coleta_preco_fornecedor_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CopyColetaPrecoFornecedorUseCase
 */

export class CopyColetaPrecoFornecedorUseCase implements ICopyColetaPrecoFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async copyColetaPrecoFornecedor(
    idColetaPrecoFornecedor: number,
    idFornecedor: number,
  ): Promise<void> {
    await this.repository.copyColetaPrecoFornecedor(
      idColetaPrecoFornecedor,
      idFornecedor,
    );
  }
}
